<template>
  <div v-if="datas.length">
    <div class="couponCard" v-for="item in datas" :key="item.id" @click="deatail(item)">
      <div class="header fvlr" :class="{ disable: item.statusFlag !== 2 }">
        <div class="bg"></div>
        <div>有效期：{{ item.activeStartTime + ' - ' + item.activeEndTime }}</div>
        <div class="reminder" v-if="item.isReminder && listStatusFlag === 1">即将过期</div>
        <div v-else>{{ status(item.statusFlag) }}</div>
      </div>
      <div class="content fvl">
        <div class="bg"></div>
        <div class="left fhcud">
          <div class="rightsTypeBox rightsTypeItem" :class="{ activeDiscount: item.rightTypeFlag === 11, hiddenTypeName: item.rightTypeFlag === 12 }">
            <img v-if="item.rightTypeFlag!=13" src="../../assets/images/lineShort.png" alt="" />
            <span>{{ item.typeName }}</span>
            <img v-if="item.rightTypeFlag!=13" class="imgReverse" src="../../assets/images/lineShort.png" alt="" />
          </div>
          <div class="discont" :class="{ discontDisable: item.statusFlag !== 2 }">
            {{ item.discountStr }}
          </div>
          <div>{{ item.thresholdStr }}</div>
        </div>
        <div class="right fhlc">
          <div class="name">{{ item.rightName }}</div>
          <div class="limitStr" v-html="useState(item)"></div>
        </div>
        <img v-if="item.statusFlag === 2" class="checkDetail" src="../../assets/images/arrowRightBlue.png" alt="" />
        <img v-else class="checkDetail" src="../../assets/images/arrowRightGray.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { couponList } from '@/util/plan'
export default {
  props: ['datas', 'dealer', 'listStatusFlag'],
  setup(props, { emit }) {
    let { datas, dealer, listStatusFlag } = toRefs(props)
    const state = reactive({
      datas: couponList(datas.value),
      dealer,
      listStatusFlag
    })
    let status = n => {
      let result = ['', '未生效', '可使用', '已过期', '暂不可用', '已使用','使用中']
      return result[n]
    }
    let useState = item => {
      let isUse = ['', '不限制', '年', '季度', '月']
      let frequency = item.phaseTypeFlag === 1 ? '' : `,本${isUse[item.phaseTypeFlag]}可使用${item.phasedResidueUseNum}次`

      let phaseStr = item.phaseTypeFlag === 1 ? `` : `，每${item.phaseTypeName}可使用${item.phasedUseNum}次`
      let total = item.totalUseNum
      let used = item.usedNum
      let resut =
        total > 0
          ? `共可使用${total}次${phaseStr} <br> 剩余${total - used}次${frequency}`
          : !(phaseStr || frequency)
          ? '不限使用次数'
          : `${phaseStr.substring(1)}<br>${frequency.substring(1)}`
      return resut
    }
    let deatail = item => {
      item.dealer = state.dealer
      emit('showDeatail', item)
      state.useState = useState(item)
    }

    return {
      ...toRefs(state),
      deatail,
      status,
      useState
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
}

.header {
  font-size: 12px;
  color: #ffffff;
  padding: 6px 10px 7px 20px;
  background-color: #3088c5;
  position: relative;
  .bg {
    background: url('../../assets/images/bg3.png') 0 0 repeat-y #f7f7f7;
    background-size: 96%;
  }
}
.disable {
  background-color: #cccccc;
  .bg {
    background: url('../../assets/images/bg2.png') 0 0 repeat-y #f7f7f7;
    background-size: 96%;
  }
}
.content {
  height: 65px;
  padding: 10px 0;
  position: relative;
  background-color: #ffffff;
  .bg {
    background: url('../../assets/images/bg1.png') 0 0 repeat-y #f7f7f7;
    background-size: 120%;
  }
}
.left {
  width: 110px;
  border-right: 2px dashed #ebedf0;
  padding: 0;
  font-size: 10px;
  height: 100%;
  font-size: 12px;
  color: #999999;
  .rightsTypeItem {
    color: #666666;
    font-size: 12px;
  }
  .rightsTypeBox {
    span {
      margin: 0 4px;
      vertical-align: middle;
    }
    img {
      margin: auto 0;
      vertical-align: middle;
    }
  }
  .activeDiscount {
    img {
      width: 14px;
    }
  }
  .discontDisable {
    color: #666666;
    opacity: 0.6;
  }
}
.right {
  width: calc(100% - 110px);
  padding-left: 15px;
  box-sizing: border-box;
  color: #666666;
  font-size: 12px;
  height: 100%;
}
.name {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 6px;
}
.limitStr {
  text-align: left;
  line-height: 1.8;
  font-size: 12px;
}
.discont {
  color: #3088c5;
  font-size: 16px;
  font-weight: bold;
}
.checkDetail {
  width: 16px;
  height: 16px;
  margin-right: 16px;
}
.couponCard {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
}
.imgReverse {
  transform: rotate(180deg);
}
.hiddenTypeName {
  height: 0;
  visibility: hidden;
}
.reminder{
  color: red;
}
</style>
